import React from "react";
import {
  FooterInfo,
  FooterImageWrapper,
  FooterContactWrapper,
} from "./styles";
import FooterImageBig from "../../assets/home/background-bacve.jpg";
import BacchusLogo from "../../assets/home/bacchus-drinks-logo.svg";
import FbIcon from "../../assets/home/fb.svg";
import YtIcon from "../../assets/home/yt.svg";
import InstaIcon from "../../assets/home/insta.svg";
import ContactForm from "./ContactForm";

const NewFooter = () => {
  return (
    <React.Fragment>
      <FooterInfo>
        <FooterContactWrapper>
          <img
            src={BacchusLogo}
            style={{ width: "150px", marginBottom: "60px" }}
            alt="Bacchus logo"
          />
          <p style={{ marginBottom: "10px" }}>
            <strong>Phone</strong>
          </p>
          <a
            href="tel:0795315583"
            style={{
              marginBottom: "25px",
              color: "#1b2c58",
              textDecoration: "none",
            }}
          >
            079 531 55 83
          </a>
          <p style={{ marginBottom: "10px" }}>
            <strong>E-mail</strong>
          </p>
          <a
            href="mailto:info@bacchus-drinks.ch"
            style={{
              marginBottom: "25px",
              color: "#1b2c58",
              textDecoration: "none",
            }}
          >
            info@bacchus-drinks.ch
          </a>
          <p style={{ marginBottom: "10px" }}>
            <strong>Address</strong>
          </p>
          <p>Bacchus Drinks GmbH</p>
          <address>
            <p>Chemin des Artisans 6</p>
            <p>1580 Avenches</p>
          </address>
        </FooterContactWrapper>
        <FooterImageWrapper>
          <img src={FooterImageBig} style={{ width: "100%", height: "100%" }} alt="Bacve vina"/>
          <ContactForm />
        </FooterImageWrapper>
      </FooterInfo>
      <div
        style={{
          height: "80px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
          color: "#001753",
          textAlign: "center",
        }}
      >
        <p>© 2021 - {new Date().getFullYear()} Bacchus Drinks GmbH. All rights reserved.</p>
        <div style={{ display: "flex", alignItems: "center" }}>
          <a
            href="https://www.facebook.com/profile.php?id=100083863497733"
            target={"_blank"}
            rel="noreferrer"
            style={{ margin: "15px" }}
          >
            <img src={FbIcon} style={{ height: "15px" }} alt="Facebook icon" />
          </a>
          <a
            href="https://www.instagram.com/bacchus_drinks/"
            target={"_blank"}
            rel="noreferrer"
            style={{ margin: "15px" }}
          >
            <img
              src={InstaIcon}
              style={{ height: "15px" }}
              alt="Instagram icon"
            />
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=100083863497733"
            target={"_blank"}
            rel="noreferrer"
            style={{ margin: "15px" }}
          >
            <img src={YtIcon} style={{ height: "15px" }} alt="Youtube icon" />
          </a>
        </div>
      </div>
    </React.Fragment>
  );
};
export default NewFooter;
